import { useEffect, useMemo, useState, useContext } from 'react';
import { connect } from 'react-redux';
import socketio from 'socket.io-client';
import { API_ENDPOINT_V1 } from '../../config';
import { SMSChatProvider, SMSChatContext } from './SMSChatContext';
import SMSChatSidebar from './SMSChatSidebar';
import SMSChatMessageBox from './SMSChatMessageBox';
import { renderText } from './utils';

import SMSChatErrorBoundary from './SMSChatErrorBoundary';

const SMSConnectionWrapper = ({ channelType, userDetails }) => {
  return (
    <div className="nk-chat" key={channelType}>
      <SMSChatProvider key={channelType}>
        <SMSChatErrorBoundary>
          <SMSContent channelType={channelType} userDetails={userDetails} />
        </SMSChatErrorBoundary>
      </SMSChatProvider>
    </div>
  );
};


const SMSContent = ({ channelType, userDetails }) => {
  const [newSMS, setNewSMS] = useState(null);
  const { updateConversationPreview, selectedConversation, setMessages, messages } = useContext(SMSChatContext);

  const socket = useMemo(() => {
    return socketio(API_ENDPOINT_V1.replace(/\/api$/, ''), {
      transports: ['websocket'],
    });
  }, []);

  useEffect(() => {
    if (userDetails) {
        let userDetailsObj = {
            userId: userDetails?.id,
            name: userDetails?.firstName,
            userImage: userDetails?.profilePictureUrl,
          };
      socket.emit('register', userDetailsObj);
    }
    return () => socket.disconnect();
  }, [userDetails, socket]);

useEffect(() => {
  const handleNewSMS = (data) => {
    try {
      if (!data || data.channelType !== channelType) return;

      const msg = data?.message;

      // Ensure message is valid object
      if (!msg || typeof msg !== "object") return;

      // Ensure body is string (avoid {} crash)
      const safeBody = renderText(msg.body);

      // Update list preview
      updateConversationPreview(
        data.conversationId,
        safeBody,
        msg?.createdAt
      );

      // If this conversation is open, append message
      if (selectedConversation?.id === data.conversationId) {
        setMessages((prev) => {
          const arr = Array.isArray(prev) ? prev : [];
          if (msg?.id && arr.find((m) => m.id === msg.id)) return arr;

          // keep message but ensure body always string
          const normalizedMsg = { ...msg, body: safeBody };
          return [normalizedMsg, ...arr];
        });
      }
    } catch (e) {
      console.error("new_sms_receive handler failed:", e);
    }
  };

  socket.on("new_sms_receive", handleNewSMS);

  return () => {
    socket.off("new_sms_receive", handleNewSMS);
  };
}, [socket, channelType, selectedConversation, setMessages, updateConversationPreview]);


  return (
    <>
      <SMSChatSidebar channelType={channelType} socket={socket} />
      <SMSChatMessageBox channelType={channelType} socket={socket} />
    </>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state?.auth?.userData,
});

export default connect(mapStateToProps)(SMSConnectionWrapper);
